module.exports = require("screen");


/*****************
 ** WEBPACK FOOTER
 ** external "screen"
 ** module id = 24
 ** module chunks = 0
 **/